import { getAppTourUrl } from '../../constants/appTour'
import { branding } from '../../constants/branding'
import { headerStrings } from '../../constants/strings'
import { cn } from '../../utils/cn'
import { Icon } from '../Icon'
import {
  MOBILE_HEADER_ICON_SIZE,
  mobileHeaderIconButtonClass,
} from '../Header/styles'

type AppTourLinkProps = {
  compact?: boolean
}

export function AppTourLink({ compact = false }: AppTourLinkProps) {
  const href = getAppTourUrl(branding.serviceName)

  if (!href) return null

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={headerStrings.appTourLabel}
      className={cn(
        'inline-flex shrink-0 items-center justify-center transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40',
        // compact（スマホの上部バー）は隣のハンバーガー・組織切り替えと同じ大きさのアイコンボタン
        compact
          ? `${mobileHeaderIconButtonClass} rounded-2xl text-ink hover:bg-neutral-25`
          : 'whitespace-nowrap rounded-[var(--btn-radius)] bg-accent px-4 py-2 text-xs font-semibold text-white shadow-accent hover:-translate-y-0.5 hover:bg-accent-mid hover:shadow-accent-strong focus-visible:ring-offset-2 focus-visible:ring-offset-white',
      )}
    >
      {compact ? (
        <Icon
          icon="help"
          width={MOBILE_HEADER_ICON_SIZE}
          height={MOBILE_HEADER_ICON_SIZE}
        />
      ) : (
        headerStrings.appTour
      )}
    </a>
  )
}
